import OwlCarousel from 'react-owl-carousel-autoheight';

import 'owl.carousel/dist/assets/owl.carousel.css';

import 'owl.carousel/dist/assets/owl.theme.default.css';

import { useEffect, useRef, useState } from 'react';

import TableRecord from './Tables/TableRecord';

const ResultHeader = ((props) => {

    const CarouselRef = useRef();

    const [results, setResults] = useState(props.result);

    const [carouselReady, setCarouselReady] = useState(false);

    const [mounted, setMounted] = useState(false);

    useEffect(() => {

        if (!props.result) return;
        setResults(props.result);

        setMounted(true);
    }, [props]);

    useEffect(() => {
        if (!carouselReady) return;
        setTimeout(() => {
            CarouselRef.current.to(1, 0);
            CarouselRef.current.to(0, 0);
        }, 500);
    }, [carouselReady]);

    if (!mounted) return;

    return (
        <>
            <div className='result-wrapper'>
                <Tabs changeTabs={(val) => {
                    CarouselRef.current.to(val, 500);
                }} />

                <OwlCarousel
                    onInitialize={() => setCarouselReady(true)}
                    ref={slider => (CarouselRef.current = slider)}
                    className='owl-theme'
                    loop={false}
                    margin={10}
                    nav={false}
                    dots={false}
                    items={1}
                    autoHeight={true}
                    touchDrag={false}
                    mouseDrag={false}>
                    <div className='item'>
                        <TableRecord data={results} type={1} />
                    </div>
                    <div className='item'>
                        <TableRecord data={results} type={2} />
                    </div>
                    <div className='item'>
                        <TableRecord data={results} type={3} />
                    </div>
                    <div className='item'>
                        <TableRecord data={results} type={4} />
                    </div>

                </OwlCarousel>

            </div>
        </>
    )
});


const Tabs = ((props) => {

    const [selected, setSelected] = useState(0);

    const ChangeSection = ((val) => {
        setSelected(val);
        props.changeTabs(val);
    });

    return (
        <>
            <ul className='game-result-header'>
                <li className={`c-pointer ${selected == 0 && 'active'}`} onClick={() => ChangeSection(0)}>출발패턴</li>
                <li className={`c-pointer ${selected == 1 && 'active'}`} onClick={() => ChangeSection(1)}>줄수패턴</li>
                <li className={`c-pointer ${selected == 2 && 'active'}`} onClick={() => ChangeSection(2)}>홀짝패턴</li>
                <li className={`c-pointer ${selected == 3 && 'active'}`} onClick={() => ChangeSection(3)}>출줄패턴</li>
            </ul>
        </>
    )
});
export default ResultHeader;